function DetailMetaDivider() {
  return <span className="project-type-meta-divider">|</span>;
}
function DetailMetaRow({ children, className = "" }) {
  return <div className={["project-type-meta", className].filter(Boolean).join(" ")}>{children}</div>;
}
export { DetailMetaDivider };
export default DetailMetaRow;
